var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeDecreasedRevenue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.437,
    height: 46.23,
    viewBox: "0 0 58.437 46.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5200",
    "data-name": "Group 5200",
    transform: "translate(-877.657 -650)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5199",
    "data-name": "Group 5199",
    transform: "translate(882 697.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M19.633,18.881a2.648,2.648,0,0,1-2.794-2.5,2.648,2.648,0,0,1,2.794-2.5,2.648,2.648,0,0,1,2.794,2.5,1.47,1.47,0,1,0,2.941,0A5.484,5.484,0,0,0,21.1,11.16V8.66a1.47,1.47,0,1,0-2.941,0v2.5A5.483,5.483,0,0,0,13.9,16.381a5.592,5.592,0,0,0,5.735,5.441,2.648,2.648,0,0,1,2.794,2.5,2.648,2.648,0,0,1-2.794,2.5,2.648,2.648,0,0,1-2.794-2.5,1.47,1.47,0,1,0-2.941,0,5.484,5.484,0,0,0,4.265,5.221v2.5a1.47,1.47,0,0,0,2.941,0v-2.5a5.4,5.4,0,0,0-1.471-10.662Z",
    transform: "translate(2.367 -47.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M58.53,20.645H45.809a1.47,1.47,0,0,0,0,2.941h9.044L42.427,36.013,32.132,25.646a1.421,1.421,0,0,0-2.059,0L4.191,51.454a1.421,1.421,0,0,0,0,2.059,1.422,1.422,0,0,0,2.059,0L31.029,28.807,41.4,39.1a1.422,1.422,0,0,0,2.059,0l13.6-13.6V34.91a1.47,1.47,0,1,0,2.941,0V22.116a1.475,1.475,0,0,0-1.47-1.47Z",
    transform: "matrix(-0.998, 0.07, -0.07, -0.998, 59.274, 15.285)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    transform: "translate(2 -47.354)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18.5,
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDecreasedRevenue);
export default __webpack_public_path__ + "static/media/home-decreased-revenue.1ea1ee07899a55b311bd8b86a2f6a227.svg";
export { ForwardRef as ReactComponent };